module.exports = __webpack_public_path__ + "img/west-vvip-gal-17.f9ff86c3.jpg";